import React from 'react';
import PropTypes from 'prop-types';

import { subscriptionPlans } from 'App/config';
import YesIcon from 'Icons/YesIcon';
import NoIcon from 'Icons/NoIcon';

import './tiers.scss';

const yes = <YesIcon className="text-success mr-1" />;
const no = <NoIcon className="text-danger mr-1" />;

const SubscriptionTier = props => {
  const { bestTierLabel, plan } = props;
  const isNotCheapestPlan = plan.price > subscriptionPlans[0].price;
  return <article className={`tier ${!!bestTierLabel && 'tier--best'}`}>
    <div className="tier__best-offer">{bestTierLabel}</div>
    <h4 className="tier__title">Abonament "{plan.label}"</h4>
    <div className="tier__price">
      <span className="tier__order-amount">{plan.ordersAmount} zamówień w miesiącu</span>
      <span className="tier__price-number">{plan.price} zł</span>
      <span className="tier__price-text">per restauracja</span>
    </div>
    <ul className="tier__offer-list">
      <li className="tier__offer-item">{yes} własna strona www</li>
      <li className="tier__offer-item">{yes} budowanie bazy klientów</li>
      <li className="tier__offer-item">{yes} statystyki i raporty</li>
      <li className="tier__offer-item">{yes} moduł marketingowy</li>
      {<li className="tier__offer-item">{isNotCheapestPlan ? yes : no} pierwsze 300zł do wydania na reklamę za darmo!</li>}
    </ul>
    {props.children}
  </article>;
};

SubscriptionTier.propTypes = {
  bestTierLabel: PropTypes.string,
  children: PropTypes.element,
  plan: PropTypes.object.isRequired,
};

export default SubscriptionTier;